export default "__VITE_ASSET__m3J1hVFo__"